import { ChangeEvent } from "react";

import { TableFilterProps } from "./TableFilter.types";
import styles from "./TableFilter.module.scss";

type NumberRange = [number | null, number | null];

export const NumberFilterComponent: React.FC<TableFilterProps> = ({ value, onChange }) => {
  const [minimum, maximum] = (value as NumberRange | undefined) ?? [null, null];

  const updateRange = (index: 0 | 1, rawValue: string) => {
    const nextRange: NumberRange = [minimum, maximum];
    nextRange[index] = rawValue === "" ? null : Number(rawValue);
    onChange(nextRange.every((bound) => bound === null) ? undefined : nextRange);
  };

  return (
    <div className={styles.range}>
      <input
        className={styles.control}
        type="number"
        value={minimum ?? ""}
        onChange={(event: ChangeEvent<HTMLInputElement>) => updateRange(0, event.target.value)}
        aria-label="Minimum value"
        placeholder="Min"
      />
      <input
        className={styles.control}
        type="number"
        value={maximum ?? ""}
        onChange={(event: ChangeEvent<HTMLInputElement>) => updateRange(1, event.target.value)}
        aria-label="Maximum value"
        placeholder="Max"
      />
    </div>
  );
};